import { render, staticRenderFns } from "./RsyncScript.vue?vue&type=template&id=1228e1ef&scoped=true&"
import script from "./RsyncScript.vue?vue&type=script&lang=js&"
export * from "./RsyncScript.vue?vue&type=script&lang=js&"
import style0 from "./RsyncScript.vue?vue&type=style&index=0&id=1228e1ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1228e1ef",
  null
  
)

component.options.__file = "RsyncScript.vue"
export default component.exports